import { isImpersonationActive, useAuth } from "@healthos/auth/react";
import { getWhoami, queryKeys, useMemberName as useSharedMemberName } from "@healthos/client-data";
import { type MemberName, memberNameFromStored } from "@healthos/shared";
import { useQuery } from "@tanstack/react-query";
import { client } from "../api/healthos";
import { readEnv } from "../env";

/** The signed-in member's name: Keycloak /userinfo, then GET /api/me/whoami. Never the token. */
export function useMemberName(): MemberName | undefined {
  const { state } = useAuth();
  const user = state.status === "signedIn" ? state.user : null;
  return useSharedMemberName({
    token: user?.access_token ?? null,
    userId: user?.profile.sub ?? null,
    issuer: readEnv().authority,
    clientFactory: async () => client(),
  });
}

/** The impersonated member's stored name; /userinfo can't answer for an impersonation token. */
export function useImpersonatedMemberName(): MemberName | undefined {
  return useQuery({
    queryKey: queryKeys.whoamiOnboardingGate,
    queryFn: () => getWhoami(client()),
    select: (whoami) => memberNameFromStored(whoami.firstName, whoami.lastName),
    enabled: isImpersonationActive(),
    staleTime: 60_000,
  }).data;
}
